









































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import {
    SideBar,
    AppMain,
    HeaderBar
} from "../homenew/components";
@Component({
    components: {
        HeaderBar,
    },
})
export default class index extends Vue {
    async mounted() {
    }
    isShowLeft: boolean = false
    enter() {
        this.isShowLeft = true
        this.isShowRight = true
    }
    leave() {
        this.isShowLeft = false
        this.isShowRight = false
    }
    isShowRight: boolean = false
    toShop(){
        localStorage.setItem("isPad",'false');
        this.$router.push('./login')
    }
    toMen(){
        localStorage.setItem("isPad",'true');
        this.$router.push('./pad/padLogin')
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/loginNew.vue